import { Controller } from "@hotwired/stimulus"
import { average } from "../echart-helper";

let predictContractChartByPerson;

export default class extends Controller {
  connect() {
    predictContractChartByPerson = echarts.init(document.getElementById('predict-contract-chart-by-person'));
    const personXAxis = JSON.parse(this.data.get("person_x_axis"));
    const personTraceProject = JSON.parse(this.data.get("person_trace_project"));
    const personTraceContract = JSON.parse(this.data.get("person_trace_contract"));
    const personToSignedContract = JSON.parse(this.data.get("person_to_signed_contract"));
    const isDarkTheme = document.body.classList.contains('dark-theme');
    const chartTitleColor = isDarkTheme ? '#f8f9fa' : '#212529';
    const chartTextColor = isDarkTheme ? '#d7dfeb' : '#495057';
    const chartAxisColor = isDarkTheme ? '#aebccc' : '#6c757d';
    const chartSplitLineColor = isDarkTheme ? 'rgba(215, 223, 235, 0.35)' : '#d9dfe7';
    const chartDataLabelStyle = isDarkTheme ? {
      color: chartTitleColor,
      textBorderColor: '#111827',
      textBorderWidth: 2
    } : {};
    const chartTooltipStyle = {
      backgroundColor: isDarkTheme ? '#202a3a' : '#ffffff',
      borderColor: chartAxisColor,
      textStyle: { color: chartTitleColor }
    };

    const personSum = [];
    for (let index = 0; index < personXAxis.length; ++index) {
      personSum.push(personTraceProject[index]+personTraceContract[index]+personToSignedContract[index]);
    }
    const avgPersonSum = average(personSum);

    const option_by_person = {
        legend: {
            data: ['汇总','跟踪项目','跟踪合同','待签合同'],
            align: 'left',
            textStyle: { color: chartTextColor }
        },
        tooltip: {
          trigger: 'axis',
          ...chartTooltipStyle,
          axisPointer: {
            type: 'cross',
            label: { color: chartTitleColor }
          }
        },
        grid: {
          left: 60,
          right: 120,
          top: 50,
          bottom: 60
        },
        toolbox: {
          iconStyle: { borderColor: chartTextColor },
          feature: {
            dataView: {},
            saveAsImage: {
                pixelRatio: 2
            }
          }
        },
        xAxis: {
          data: personXAxis,
          silent: true,
          axisLabel: {
            color: chartTextColor,
            interval: 0,
            rotate: -40
          },
          axisLine: { lineStyle: { color: chartAxisColor } },
          axisTick: { lineStyle: { color: chartAxisColor } },
          splitLine: {
              show: false
          }
        },
        yAxis: [{
          type: 'value',
          name: '跟踪合同额（万元）',
          position: 'left',
          axisLabel: {
            color: chartTextColor,
            formatter: '{value}万'
          },
          nameTextStyle: { color: chartTitleColor },
          axisLine: { lineStyle: { color: chartAxisColor } },
          axisTick: { lineStyle: { color: chartAxisColor } },
          splitLine: { lineStyle: { color: chartSplitLineColor } }
        }],
        series: [{
          name: '汇总',
          type: 'line',
          symbol: 'circle',
          symbolSize: 8,
          data: personSum,
          label: {
            show: true,
            position: 'top',
            ...chartDataLabelStyle
          },
          markLine: {
            label: {
              formatter: '平均汇总金额{c}',
              ...chartDataLabelStyle
            },
            lineStyle: {
              type: 'solid',
              width: 1
            },
            data: [
              {
                yAxis: avgPersonSum
              }
            ]
          }
        },{
          name: '跟踪项目',
          type: 'bar',
          data: personTraceProject,
          label: {
            show: true,
            position: 'top',
            ...chartDataLabelStyle
          }
        },{
          name: '跟踪合同',
          type: 'bar',
          data: personTraceContract,
          label: {
            show: true,
            position: 'top',
            ...chartDataLabelStyle
          }
        },{
          name: '待签合同',
          type: 'bar',
          data: personToSignedContract,
          label: {
            show: true,
            position: 'top',
            ...chartDataLabelStyle
          }
        }]
    };

    const seriesNameMapping = option_by_person.legend.data;
    function drill_down_person_detail(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'bar') {
          const person_name = personXAxis[params.dataIndex];
          const month_name = $('#month_name').val();
          const sent_data = { person_name, month_name, series_name: seriesNameMapping[params.seriesIndex] };
          let drill_down_url = '/report/people_predict_contract/drill_down_person_detail';

          $.ajax(drill_down_url, {
            data: sent_data,
            dataType: 'script'
          });
        }
      }
    }

    predictContractChartByPerson.setOption(option_by_person, false);
    predictContractChartByPerson.on('click', drill_down_person_detail);

    setTimeout(() => {
      predictContractChartByPerson.resize();
    }, 200);
  }

  layout() {
    predictContractChartByPerson.resize();
  }

  disconnect() {
    predictContractChartByPerson.dispose();
  }
}
